import axios from "axios";
import { getAuth } from "firebase/auth";

const BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net"; 

class RatingService {
  static async sendReview(reviewData) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error('❌ Пользователь не авторизован');

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error('❌ Не удалось получить токен');

      // 👇 Добавляем worker_id в тело запроса
      const payload = {
        ...reviewData,
        worker_id: currentUser.uid,
      };

      const response = await axios.post(
        `${BASE_URL}/rate_company`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("✅ Review sent:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Error sending review:", error.response?.data || error.message);
      throw error;
    }
  }
}

export default RatingService;